import React from 'react'
import Toggle from '../Toggle/Toggle'

import './Navbar.css'
import {Link} from 'react-scroll'
import { themeContext } from '../../Context'
import { useContext } from "react";

const Navbar = () => {

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode
    return (
        <div className="navbar">
        <div className='n-wrapper' style={{background : darkMode? 'black': 'white'}}>
            <div className="n-left">
                <div className="n-name">Divakar</div>
                <Toggle className="nav-toggle"/>
            </div>
            <div className="n-right">
                <div className="n-list">
                    <ul>
                        <Link spy={true} to='Navbar' smooth={true} activeClass="activeClass">
                        <li>Home</li>
                        </Link>
                        <Link spy={true} to='Services' smooth={true} >
                        <li>Services</li>
                        </Link>
                        <Link spy={true} to='Experience' smooth={true} >
                        <li>Experience</li>
                        </Link>
                        <Link spy={true} to='Portfolio' smooth={true} >
                        <li>Portfolio</li>
                        </Link>
                        <Link spy={true} to='Testimonials' smooth={true} >
                        <li>Testimonials</li>
                        </Link>
                    </ul>
                </div>
                <Link spy={true} to='Contact' smooth={true} >
                <button className="button n-button">
                    Contact
                </button>
                </Link>

            </div>

        </div>
        </div>
    )
}

export default Navbar